import { DeviceUtil } from "../device/DeviceUtil";
import { GraphicsUtil } from "./GraphicsUtil";
/**
 * FontUtil.ts
 */
export class FontUtil {
    static createPixiTextStyle(fontProperties) {
        let font = fontProperties.font;
        let style = {};
        style["textBaseline"] = fontProperties.textBaseline;
        style["fontFamily"] = font.family;
        style["fontWeight"] = font.weight;
        let fontSize = fontProperties.size;
        if (font.hasScale()) {
            fontSize = Math.floor(fontSize * font.scale);
        }
        style["fontSize"] = fontSize;
        style["fill"] = fontProperties.colour;
        style["fillGradientStops"] = fontProperties.gradientStops;
        style["align"] = "center";
        style["lineJoin"] = fontProperties.lineJoin;
        style["miterLimit"] = fontProperties.miterLimit;
        style["lineHeight"] = fontProperties.lineHeight;
        let stroke = fontProperties.stroke;
        if (stroke) {
            style["stroke"] = stroke.colour;
            style["strokeThickness"] = stroke.thickness;
        }
        let dropShadow = fontProperties.dropShadow;
        if (dropShadow) {
            style["dropShadow"] = true;
            style["dropShadowAngle"] = GraphicsUtil.toRadians(dropShadow.angle);
            style["dropShadowColor"] = dropShadow.colour || "#000000";
            style["dropShadowDistance"] = dropShadow.distance;
            style["dropShadowAlpha"] = dropShadow.alpha;
            if (!DeviceUtil.isIos()) {
                style["dropShadowBlur"] = dropShadow.blur;
            }
        }
        let paddingPercentage = font.paddingPercentage;
        if (paddingPercentage) {
            style["padding"] = Math.ceil(fontProperties.size * font.paddingPercentage);
        }
        if (!isNaN(fontProperties.leading)) {
            style["leading"] = fontProperties.leading;
        }
        if (!isNaN(fontProperties.letterSpacing)) {
            style["letterSpacing"] = fontProperties.letterSpacing;
        }
        style["trim"] = fontProperties.trim;
        return style;
    }
    ;
}
//# sourceMappingURL=FontUtil.js.map